/* ============================================================================
   Talkblox — โลโก้
   ----------------------------------------------------------------------------
   ใช้ไฟล์จริงและเพิ่ม responsive variants เพื่อไม่ส่งไฟล์ใหญ่เกินขนาดที่
   header / footer แสดงจริง โดยยังคงไฟล์ต้นฉบับเป็น fallback
   ========================================================================== */

import logo from './assets/talkblox-logo.webp';
import logo200 from './assets/talkblox-logo-200w.webp';
import logo320 from './assets/talkblox-logo-320w.webp';
import logo480 from './assets/talkblox-logo-480w.webp';

export const LOGO_SRC = logo;
export const LOGO_SRCSET = `${logo200} 200w, ${logo320} 320w, ${logo480} 480w, ${logo} 640w`;
